import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8a4d79ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "manage-header" }
const _hoisted_2 = { class: "manage-header-left" }
const _hoisted_3 = {
  key: 0,
  class: "main"
}
const _hoisted_4 = { class: "userInfo space-top" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-right" }, null, -1))
const _hoisted_6 = ["src"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-right end" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-right" }, null, -1))
const _hoisted_11 = { class: "groupID" }
const _hoisted_12 = ["title"]
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "footer space-top" }
const _hoisted_15 = {
  key: 3,
  class: "admin"
}
const _hoisted_16 = {
  key: 0,
  class: "admin-list"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 1,
  class: "admin-content space-top"
}
const _hoisted_19 = {
  key: 2,
  class: "admin-list last"
}
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 0,
  class: "delDialog-title"
}
const _hoisted_22 = {
  key: 1,
  class: "delDialog-title"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ManageName = _resolveComponent("ManageName")!
  const _component_ManageMember = _resolveComponent("ManageMember")!
  const _component_ManageNotification = _resolveComponent("ManageNotification")!
  const _component_Slider = _resolveComponent("Slider")!
  const _component_Transfer = _resolveComponent("Transfer")!
  const _component_Mask = _resolveComponent("Mask")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("i", {
      class: "icon icon-chat-setting",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleShow && _ctx.toggleShow(...args)))
    }),
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["manage", [_ctx.isH5 ? 'manage-h5' : '']]),
          ref: "dialog"
        }, [
          _createElementVNode("header", _hoisted_1, [
            (_ctx.isH5 && !_ctx.currentTab)
              ? (_openBlock(), _createElementBlock("i", {
                  key: 0,
                  class: "icon icon-back",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleShow && _ctx.toggleShow(...args)))
                }))
              : _createCommentVNode("", true),
            _createElementVNode("aside", _hoisted_2, [
              (_ctx.currentTab)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: "icon icon-back",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setTab('')))
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("main", null, [
                _createElementVNode("h1", null, _toDisplayString(_ctx.$t(`TUIChat.manage.${_ctx.TabName}`)), 1)
              ])
            ]),
            _createElementVNode("span", null, [
              (!_ctx.isH5)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: "icon icon-close",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleShow && _ctx.toggleShow(...args)))
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          (!_ctx.currentTab)
            ? (_openBlock(), _createElementBlock("main", _hoisted_3, [
                _createVNode(_component_ManageName, {
                  class: "space-top",
                  isAuth: _ctx.isAuth,
                  isH5: _ctx.isH5,
                  data: _ctx.conversation.groupProfile,
                  onUpdate: _ctx.updateProfile
                }, null, 8, ["isAuth", "isH5", "data", "onUpdate"]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("header", {
                    class: "userInfo-header",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setTab('member')))
                  }, [
                    _createElementVNode("label", null, _toDisplayString(_ctx.$t(`TUIChat.manage.群成员`)), 1),
                    _createElementVNode("p", null, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.conversation.groupProfile.memberCount) + _toDisplayString(_ctx.$t(`TUIChat.manage.人`)), 1),
                      _hoisted_5
                    ])
                  ]),
                  _createElementVNode("ol", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userInfo?.list?.slice(0, _ctx.showUserNum), (item, index) => {
                      return (_openBlock(), _createElementBlock("dl", { key: index }, [
                        _createElementVNode("dt", null, [
                          _createElementVNode("img", {
                            class: "avatar",
                            src: item?.avatar || 'https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png',
                            onerror: "this.src='https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png'"
                          }, null, 8, _hoisted_6)
                        ]),
                        _createElementVNode("dd", null, _toDisplayString(item?.nick || item?.userID), 1)
                      ]))
                    }), 128)),
                    (_ctx.isShowAddMember)
                      ? (_openBlock(), _createElementBlock("dl", _hoisted_7, [
                          _createElementVNode("dt", {
                            class: "avatar",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleMask('add')))
                          }, "+")
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.conversation.groupProfile.selfInfo.role === 'Owner')
                      ? (_openBlock(), _createElementBlock("dl", _hoisted_8, [
                          _createElementVNode("dt", {
                            class: "avatar",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleMask('remove')))
                          }, "-")
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("ul", {
                  class: "content space-top",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.editLableName = ''))
                }, [
                  _createElementVNode("li", {
                    onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.setTab('notification')), ["stop"]))
                  }, [
                    _createElementVNode("aside", null, [
                      _createElementVNode("label", null, _toDisplayString(_ctx.$t(`TUIChat.manage.群公告`)), 1),
                      _createElementVNode("article", null, _toDisplayString(_ctx.conversation.groupProfile.notification), 1)
                    ]),
                    _hoisted_9
                  ]),
                  (_ctx.isAdmin && _ctx.isSetMuteTime)
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 0,
                        onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.setTab('admin')), ["stop"]))
                      }, [
                        _createElementVNode("label", null, _toDisplayString(_ctx.$t(`TUIChat.manage.群管理`)), 1),
                        _hoisted_10
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("li", null, [
                    _createElementVNode("label", null, _toDisplayString(_ctx.$t(`TUIChat.manage.群ID`)), 1),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.conversation.groupProfile.groupID), 1),
                      _createElementVNode("i", {
                        class: "icon icon-msg-copy",
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleGroupIDCopy && _ctx.handleGroupIDCopy(...args))),
                        title: _ctx.$t('TUIChat.复制')
                      }, null, 8, _hoisted_12)
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("label", null, _toDisplayString(_ctx.$t(`TUIChat.manage.群头像`)), 1),
                    _createElementVNode("img", {
                      class: "avatar",
                      src: 
                _ctx.conversation?.groupProfile?.avatar ||
                'https://sdk-web-1252463788.cos.ap-hongkong.myqcloud.com/im/demo/TUIkit/web/img/constomer.svg'
              ,
                      onerror: "this.src='https://sdk-web-1252463788.cos.ap-hongkong.myqcloud.com/im/demo/TUIkit/web/img/constomer.svg'"
                    }, null, 8, _hoisted_13)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("label", null, _toDisplayString(_ctx.$t(`TUIChat.manage.群类型`)), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`TUIChat.manage.${_ctx.typeName[_ctx.conversation.groupProfile.type]}`)), 1)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("label", null, _toDisplayString(_ctx.$t(`TUIChat.manage.加群方式`)), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`TUIChat.manage.${_ctx.typeName[_ctx.conversation.groupProfile.joinOption]}`)), 1)
                  ])
                ]),
                _createElementVNode("ul", _hoisted_14, [
                  (_ctx.conversation.groupProfile.selfInfo.role === 'Owner' && _ctx.userInfo?.list.length > 1)
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 0,
                        onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.toggleMask('changeOwner')), ["stop"]))
                      }, _toDisplayString(_ctx.$t(`TUIChat.manage.转让群组`)), 1))
                    : _createCommentVNode("", true),
                  (!!_ctx.isDismissGroupAuth)
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 1,
                        onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.dismiss(_ctx.conversation.groupProfile)), ["stop"]))
                      }, _toDisplayString(_ctx.$t(`TUIChat.manage.解散群聊`)), 1))
                    : (_openBlock(), _createElementBlock("li", {
                        key: 2,
                        onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.quit(_ctx.conversation.groupProfile)), ["stop"]))
                      }, _toDisplayString(_ctx.$t(`TUIChat.manage.退出群组`)), 1))
                ])
              ]))
            : (_ctx.currentTab === 'member')
              ? (_openBlock(), _createBlock(_component_ManageMember, {
                  key: 1,
                  self: _ctx.conversation.groupProfile.selfInfo,
                  list: _ctx.userInfo.list,
                  total: ~~_ctx.conversation.groupProfile.memberCount,
                  isShowDel: _ctx.conversation.groupProfile.selfInfo.role === 'Owner',
                  onMore: _cache[14] || (_cache[14] = ($event: any) => (_ctx.getMember('more'))),
                  onDel: _ctx.submit
                }, null, 8, ["self", "list", "total", "isShowDel", "onDel"]))
              : (_ctx.currentTab === 'notification')
                ? (_openBlock(), _createBlock(_component_ManageNotification, {
                    key: 2,
                    isAuth: _ctx.isAuth,
                    data: _ctx.conversation.groupProfile,
                    onUpdate: _ctx.updateProfile
                  }, null, 8, ["isAuth", "data", "onUpdate"]))
                : (_ctx.currentTab === 'admin')
                  ? (_openBlock(), _createElementBlock("main", _hoisted_15, [
                      (_ctx.isAdmin)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("label", null, _toDisplayString(_ctx.$t(`TUIChat.manage.群管理员`)), 1),
                            _createElementVNode("ol", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.member.admin, (item, index) => {
                                return (_openBlock(), _createElementBlock("dl", { key: index }, [
                                  _createElementVNode("dt", null, [
                                    _createElementVNode("img", {
                                      class: "avatar",
                                      src: item?.avatar || 'https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png',
                                      onerror: "this.src='https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png'"
                                    }, null, 8, _hoisted_17)
                                  ]),
                                  _createElementVNode("dd", null, _toDisplayString(item?.nick || item?.userID), 1)
                                ]))
                              }), 128)),
                              _createElementVNode("dl", null, [
                                _createElementVNode("dt", {
                                  class: "avatar",
                                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.toggleMask('addAdmin')))
                                }, "+")
                              ]),
                              _createElementVNode("dl", null, [
                                (_ctx.member.admin.length > 0)
                                  ? (_openBlock(), _createElementBlock("dt", {
                                      key: 0,
                                      class: "avatar",
                                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.toggleMask('removeAdmin')))
                                    }, "-"))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isSetMuteTime)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createElementVNode("aside", null, [
                              _createElementVNode("label", null, _toDisplayString(_ctx.$t(`TUIChat.manage.全员禁言`)), 1),
                              _createElementVNode("p", null, _toDisplayString(_ctx.$t(`TUIChat.manage.全员禁言开启后，只允许群主和管理员发言。`)), 1)
                            ]),
                            _createVNode(_component_Slider, {
                              open: _ctx.conversation.groupProfile.muteAllMembers,
                              onChange: _ctx.setAllMuteTime
                            }, null, 8, ["open", "onChange"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isSetMuteTime)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createElementVNode("label", null, _toDisplayString(_ctx.$t(`TUIChat.manage.单独禁言人员`)), 1),
                            _createElementVNode("ol", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.member.muteMember, (item, index) => {
                                return (_openBlock(), _createElementBlock("dl", { key: index }, [
                                  _createElementVNode("dt", null, [
                                    _createElementVNode("img", {
                                      class: "avatar",
                                      src: item?.avatar || 'https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png',
                                      onerror: "this.src='https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png'"
                                    }, null, 8, _hoisted_20)
                                  ]),
                                  _createElementVNode("dd", null, _toDisplayString(item?.nick || item?.userID), 1)
                                ]))
                              }), 128)),
                              _createElementVNode("dl", null, [
                                _createElementVNode("dt", {
                                  class: "avatar",
                                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.toggleMask('addMute')))
                                }, "+")
                              ]),
                              _createElementVNode("dl", null, [
                                (_ctx.member.muteMember.length > 0)
                                  ? (_openBlock(), _createElementBlock("dt", {
                                      key: 0,
                                      class: "avatar",
                                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.toggleMask('removeMute')))
                                    }, "-"))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
          _createVNode(_component_Mask, {
            show: _ctx.mask,
            "onUpdate:show": _cache[19] || (_cache[19] = (e) => (_ctx.mask = e))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Transfer, {
                title: _ctx.$t(`TUIChat.manage.${_ctx.transferTitle}`),
                list: _ctx.transferList,
                isSearch: _ctx.isSearch,
                isRadio: _ctx.isRadio,
                selectedList: _ctx.selectedList,
                onSubmit: _ctx.submit,
                onCancel: _ctx.cancel,
                onSearch: _ctx.handleSearchMember,
                isH5: _ctx.isH5
              }, null, 8, ["title", "list", "isSearch", "isRadio", "selectedList", "onSubmit", "onCancel", "onSearch", "isH5"])
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(_component_Dialog, {
            title: _ctx.$t(`TUIChat.manage.删除成员`),
            show: _ctx.delDialogShow,
            isH5: _ctx.isH5,
            center: true,
            isHeaderShow: !_ctx.isH5,
            onSubmit: _cache[20] || (_cache[20] = ($event: any) => (_ctx.handleManage(_ctx.userList, 'remove'))),
            "onUpdate:show": _cache[21] || (_cache[21] = (e) => (_ctx.delDialogShow = e))
          }, {
            default: _withCtx(() => [
              (_ctx.userList.length === 1)
                ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_ctx.$t(`TUIChat.manage.确定从群聊中删除该成员？`)), 1))
                : _createCommentVNode("", true),
              (_ctx.userList.length > 1)
                ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(_ctx.$t(`TUIChat.manage.确定从群聊中删除所选成员？`)), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["title", "show", "isH5", "isHeaderShow"])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}